(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-artists"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.featured-artists').forEach(function (root) {
      var track = root.querySelector('[data-fa-track]');
      var prev = root.querySelector('[data-fa-prev]');
      var next = root.querySelector('[data-fa-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fa-dot]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('.fa__slide'));
      if (!track || slides.length < 2) return;

      function gap() {
        var cs = getComputedStyle(track);
        return parseFloat(cs.columnGap || cs.gap) || 0;
      }

      // How many cards are visible at once (1 on mobile, "cards per row" on desktop).
      function perView() {
        var sw = slides[0].getBoundingClientRect().width;
        if (!sw) return 1;
        return Math.max(1, Math.round(track.clientWidth / (sw + gap())));
      }

      function activeIndex() {
        // Which slide's left edge is closest to the scroller's scroll position.
        var pos = track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - pos);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      }

      function hasOverflow() {
        return track.scrollWidth - track.clientWidth > 2;
      }

      function update() {
        // Hide the controls entirely when every card already fits.
        root.classList.toggle('fa--no-nav', !hasOverflow());
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
        var i = activeIndex();
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - perView()); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + perView()); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-fa-dot'), 10)); });
      });

      var raf;
      function schedule() {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
